import Vue from 'vue';
import Vuex from 'vuex';

import authentication from './modules/authentication';
import boughtPackets from './modules/boughtPackets';
import code from './modules/code';
import commissions from './modules/commissions';
import countries from './modules/countries';
import error from './modules/error';
import exchange from './modules/exchange';
import fnproductPacks from './modules/fnproductPacks';
import ftoAccounts from './modules/ftoAccounts';
import futurocoin from './modules/futurocoin';
import invoices from './modules/invoices';
import mlm from './modules/mlm';
import modals from './modules/modals';
import monthlyStatement from './modules/monthlyStatement';
import payouts from './modules/payouts';
import royalBonuses from './modules/royalBonuses';
import settings from './modules/settings';
import statistics from './modules/statistics';
import ranking from './modules/ranking';
import terms from './modules/terms';
import totalIncomes from './modules/totalIncomes';
import transferHistory from './modules/transferHistory';
import tree from './modules/tree';
import user from './modules/user';

Vue.use(Vuex);

export default new Vuex.Store ({
    modules: {
        authentication,
        boughtPackets,
        code,
        commissions,
        countries,
        error,
        exchange,
        fnproductPacks,
        ftoAccounts,
        futurocoin,
        invoices,
        mlm,
        modals,
        monthlyStatement,
        payouts,
        royalBonuses,
        settings,
        statistics,
        ranking,
        terms,
        totalIncomes,
        transferHistory,
        tree,
        user
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js